import React from 'react';
import CareersHero from '../components/CareersHero';
import CareersSections from '../components/CareersSections';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ContactUs from '../components/ContactUs';

function CareersPage({ setView }) {
  return (
    <>
      <CareersHero />
      <CareersSections setView={setView} />
      <WhyChooseUsSection />
      <ContactUs />
    </>
  );
}

export default CareersPage;
